export function buildInvoiceFileName(input) {
    const parts = [
        sanitizeFileNamePart(input.number ?? "") || input.id,
        sanitizeFileNamePart(input.companyName ?? ""),
        input.kind === "e-invoice" ? "E-Rechnung" : "",
    ].filter(part => part !== "");
    const ext = input.kind === "e-invoice" ? input.ext : "pdf";
    return `${parts.join("_")}.${ext}`;
}
function sanitizeFileNamePart(value) {
    return value
        .replace(/[/\\]/g, "-")
        .replace(/[:*?"<>|\p{Cc}]/gu, "")
        .replace(/\s+/g, " ")
        .trim();
}
//# sourceMappingURL=invoiceFileName.js.map